import { RequestTypeIds } from '@src/utils/enums';
import NprForm, { getNprFormMetadata } from '@forms/final-forms/NprForm';
import type { RegistryEntry } from './types';
import { resolveNprVariant } from './configs/npr/nprVariantConfig';
import { nprVariantByRequestType } from './latestVersions';
import NonPcnForm, { getNonPcnFormMetadata } from '@forms/final-forms/NonPcnForm';

export const formRegistry: Partial<Record<number, RegistryEntry>> = {
  [RequestTypeIds.NoPermitRequired]: {
    FormComponent: NprForm as RegistryEntry['FormComponent'],
    getVariant: ({ requestTypeId, version }) =>
      resolveNprVariant({ requestTypeId, version }) ?? nprVariantByRequestType[requestTypeId],
    getMetadata: ({ version, variant }) => getNprFormMetadata({ variant, version }),
    formKeyPrefix: 'npr',
  },

  [RequestTypeIds.ActivityBasedNoPermitRequired]: {
    FormComponent: NprForm as RegistryEntry['FormComponent'],
    getVariant: ({ requestTypeId, version }) =>
      resolveNprVariant({ requestTypeId, version }) ?? nprVariantByRequestType[requestTypeId],
    getMetadata: ({ version, variant }) => getNprFormMetadata({ variant, version }),
    formKeyPrefix: 'abNpr',
  },

  [RequestTypeIds.NonPreconstructionNotification]: {
    FormComponent: NonPcnForm as RegistryEntry['FormComponent'],
    getVariant: () => 'nonPcn',
    getMetadata: () => getNonPcnFormMetadata(),
    formKeyPrefix: 'nonPcn',
  },
};
